module.exports = __webpack_public_path__ + "img/horizontal_1_1_8023.7e6991e9.png";